import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Auth, I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import {
  TERM_VER,
  HEADER_VIEW_PATTERN
} from "../../configures/val.js";

import ServiceList from './servicelist.js'

import EditAddress from './editAddress.js'
import EditPassword from './editPassword.js'
import EditPersonalData from './editPersonalData.js'
import UserProfileView from './userprofileview.js'

import MierukaManagement from './mieruka/mierukamanagement.js'
import CruiseSetting from './mieruka/cruisesetting.js'

import InvoiceList from './invoice/invoiceList.js'

import PpaProductList from './ppa/productlist.js'
import PpaUserScreenSetting from './ppa/userScreenSetting.js'

import authCheck, {getCanIseeInvoiceList} from "../util/callApi.js";
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';

const styles = {
  root: {
    flexGrow: 1,
    width: '100%',
  },
  flex: {
    flexGrow: 1,
    textAlign: "right",
    marginRight: 40,
    fontSize: "0.9rem"
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

class ButtonAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      open: false,
      value: 0,
      termVerError: false,
      display: {
        userProf: 'L_link_tab',
        invoiceList: 'L_link_tab',
        serviceList: 'L_link_tab',
        ppaProductlist: 'L_link_tab',
        ppaUserviewSetting: 'L_link_tab'
      },
      tabPattern: HEADER_VIEW_PATTERN.DEFAULT,
      canSeeInvoiceList: false,
      supplierId: null
    };
  }
  updateUserProfile = (data) => {
    this.setState({
      userData: data,
    });
  }
  updateTabPattern = (pattern) => {
    this.setState({
      tabPattern: pattern,
    });
  }
  updateSupplierId = (supplierId) => {
    this.setState({
      supplierId: supplierId,
    });
  }
  checkUser = () => {
    const that = this;
    return Auth.currentAuthenticatedUser().then(user => {
      if (!that._isMounted) { return; }
      Auth.userAttributes(user).then((result) => {
        let userData = {};
        for (let i = 0; i < result.length; i++) {
          let name = result[i].Name;
          userData[name] = result[i].Value;
        }
        this.setState({
          userData
        });
      }).catch((attrErr) => {
        this.setState({
          userData: null
        });
        // トークンが死んでいる可能性がある
        Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
      });
    }).catch(err => {
      if (!that._isMounted) { return; }
      this.setState({
        userData: null
      });
      Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
    });
  }
  async canSeeBillingList() {
    try {
      const ret = await getCanIseeInvoiceList();
      return ret;
    } catch(err) {
      return false;
    }
  }
  async closeTermVerError (that) {
    const user = await Auth.currentAuthenticatedUser();
    const authProp = {
      user,
      href: this.state.href
    };
    that.props.authProps.onStateChange('reagreeTermsDocs', authProp);
    this.setState({
      termVerError: false
    });
    return;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  async componentDidMount() {
    this._isMounted = true;
    this.checkUser();
    try {
      const authRet = await authCheck();
      if (authRet.result === 'NG') {
        window.history.pushState('', '', '/');
        this.props.authProps.onStateChange('signIn');
        return;
      }
      const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
      if (isLowVer) {
        this.setState({
          termVerError: true,
          href: window.location
        });
        return;
      }
    } catch (error) {
      console.log('error == componentDidMount == header.js');
      console.log(error);
    }
    const canSeeInvoice = await this.canSeeBillingList();
    // result が 'NG' のときリロードを促すアラート
    if (canSeeInvoice.result === 'NG') {
      alert(I18n.get('Failed to confirm access to invoice service. Please reload the screen.'));
      this.setState({
        canSeeInvoiceList: false,
        termVerError: false
      });
      return;
    }
    this.setState({
      canSeeInvoiceList: canSeeInvoice.data.result,
      termVerError: false
    });
  }
  async isTermVerError() {
    const authRet = await authCheck();
    return checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
  }
  async controlTransition(e, href) {
    e.preventDefault();
    const ret = await this.isTermVerError();
    if (ret) {
      this.setState({
        termVerError: true,
        href
      });
      return false;
    }
    window.location.href = href;
  }
  signOut = () => {
    Auth.signOut().then(() => {
      window.history.pushState("", "", "/");
      this.props.authProps.onStateChange('signIn');
    });
  }
  changeActiveDisplay = (param) => {
    let display = {};
    for (let propName in this.state.display) {
      if (propName === param) {
        display[propName] = 'L_link_tab headerSelected';
      } else {
        display[propName] = 'L_link_tab';
      }
    }
    this.setState({
      display
    });
  }
  updatePpa = (value, classes, userDisplay) => {
    return(
      <>
        <span className='L_headerTitle'>{I18n.get('User view management')}</span>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          scrollable
          scrollButtons="off"
          className={"L_tabBarBack"}
          classes={{ root: classes.tabsRoot }}
        >
          <Link to='/ppa/productlist' className={this.state.display.ppaProductlist}>{I18n.get('Product list')}</Link>
          <Link to='/ppa/userviewsetting' className={this.state.display.ppaUserviewSetting}>{I18n.get('User screen setting')}</Link>
        </Tabs>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {userDisplay}
        </Typography>
        <Button color="inherit" onClick={this.signOut} className={'L_logout'}>{I18n.get('LOGOUT')}</Button>
      </>
    );
  }
  updateDefault = (value, classes, userDisplay) => {
    return(
      <>
        <span className='L_headerTitle'>{I18n.get('My page')}</span>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          scrollable
          scrollButtons="off"
          className={"L_tabBarBack"}
          classes={{ root: classes.tabsRoot }}
        >
          <Link to='/' className={this.state.display.userProf}>{I18n.get('User profile')}</Link>
          <Link to='/servicelist' className={this.state.display.serviceList}>{I18n.get('Service list')}</Link>
          {this.state.canSeeInvoiceList ? <Link to='/invoicelist' className={this.state.display.invoiceList}>{I18n.get('Invoices')}</Link> : <span></span>}
        </Tabs>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {userDisplay}
        </Typography>
        <Button color="inherit" onClick={this.signOut} className={'L_logout'}>{I18n.get('LOGOUT')}</Button>
      </>
    );
  }
  switchHeaderTabList = (value, classes, userDisplay) => {
    switch(this.state.tabPattern) {
      case HEADER_VIEW_PATTERN.DEFAULT:
        return(this.updateDefault(value, classes, userDisplay));
      case HEADER_VIEW_PATTERN.PPA:
        return(this.updatePpa(value, classes, userDisplay));
      default :
        return(this.updateDefault(value, classes, userDisplay));
    }
  }
  render() {
    const { value } = this.state; // 発電所管理画面のa要素が value == 1 に該当
    const { classes } = this.props;

    let userDisplay = '';
    if (this.state.userData) {
      userDisplay = this.state.userData.family_name+" "+this.state.userData.given_name;
      if (window.LAPLACEID_LOCALE === 'ja') {
        userDisplay += '様';
      }
    }
    return (
      <div className={classes.root}>
        <BrowserRouter>
          <div>
            <AppBar position="static">
              <Toolbar className={'L_menuBarBack'}>
                {this.switchHeaderTabList(value, classes, userDisplay)}
              </Toolbar>
            </AppBar>
            <div className="userProfile">
              {// 完全一致にししたいのでexactを使うようにしています
              }
              {// propsを渡したいのでcomponentではなくrenderを使うようにしています
              }
              <Route
                exact path='/'
                render={() =>
                  <UserProfileView userProf={this.state.userData} authStateChange={this.props.authProps.onStateChange} updateHeader={this.changeActiveDisplay} />
                }
              />
              <Route
                exact path="/updateaddress"
                render={(props) =>
                <EditAddress {...props} authProps={this.props.authProps} userAttribute className="userProfile" updateHeader={this.changeActiveDisplay} />
                }
              />
              <Route
                exact path="/updatepass"
                render={(props) =>
                <EditPassword {...props} authStateChange={this.props.authProps.onStateChange} className="userProfile" updateHeader={this.changeActiveDisplay} />
                }
              />
              <Route
                exact path="/updateprofile"
                render={(props) =>
                <EditPersonalData {...props} update={this.updateUserProfile} userProf={this.state.userData} authStateChange={this.props.authProps.onStateChange} updateHeader={this.changeActiveDisplay} />
                }
              />
              <Route
                exact path='/mierukamanage'
                render={(props) =>
                  <MierukaManagement authStateChange={this.props.authProps.onStateChange} />
                }
              />
              <Route
                exact path='/mierukacruise'
                render={(props) =>
                  <CruiseSetting authStateChange={this.props.authProps.onStateChange} />
                }
              />
              <Route
                exact path='/invoicelist'
                render={(props) =>
                  <InvoiceList  updateHeader={this.changeActiveDisplay} authStateChange={this.props.authProps.onStateChange} />
                }
              />
              <Route
                exact path='/servicelist'
                render={(props) =>
                  <ServiceList updateHeader={this.changeActiveDisplay} authStateChange={this.props.authProps.onStateChange} updateTabPattern={this.updateTabPattern} />
                }
              />
              <Route
                exact path='/ppa/productlist'
                render={() =>
                  <PpaProductList authStateChange={this.props.authProps.onStateChange} updateHeader={this.changeActiveDisplay} updateTabPattern={this.updateTabPattern} supplierId={this.state.supplierId} updateSupplierId={this.updateSupplierId} signOut={this.signOut} />
                }
              />
              <Route
                exact path='/ppa/userviewsetting'
                render={() =>
                  <PpaUserScreenSetting updateHeader={this.changeActiveDisplay} updateTabPattern={this.updateTabPattern} authStateChange={this.props.authProps.onStateChange} supplierId={this.state.supplierId} signOut={this.signOut} />
                }
              />
            </div>
          </div>
        </BrowserRouter>
        <LapDialog
          title={''}
          contentElem={
            <div>
              <p>{I18n.get('Terms of Service is updated.')}</p>
              <p>{I18n.get('Please reconfirm it.')}</p>
            </div>
          }
          firstButtonText={'OK'}
          firstButtonFunc={() => this.closeTermVerError(this)}
          open={this.state.termVerError}
          toClose={() => {return;}}
        />
      </div>
    );
  }
}
ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ButtonAppBar);
